import { getCrewMatrixRuleInfo } from '@/common/components/crew/utils/helpers-ts';
import Information from '@/library/components/general/Information';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

type HeaderProps = { title: string; label: string };

const Header = ({ title, label }: HeaderProps) => {
  const info = getCrewMatrixRuleInfo(label);

  return (
    <Row className="border-bottom border-platinum cpb-6 cmb-12 g-0">
      <Col className="d-flex align-items-center fw-bold text-violet fs-12">
        {title}
        {!!info && (
          <Information
            tooltipClassname="text-nowrap min-w-fit"
            className="text-violet cms-4"
            message={info}
            svgStyle={{ width: 10, height: 10 }}
          />
        )}
      </Col>
    </Row>
  );
};

export default Header;

Header.propTypes = {
  title: PropTypes.string
};
